import React from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as accountActions from 'actions/accountActions';
import CommentForm from 'commentComponents/CommentForm';

const CommentTool = (props) => {

    const {accountActions, workOrder, user, orderId, techData} = props;

    const order = workOrder.getIn(['workOrderDetails', orderId]);
    if (!order) {
        return null;
    }

    const customerDetails = order.getIn(['customerDetails', 'details']);

    if (!customerDetails) {
        return null;
    }
    const schedulingSystemDetails = order.getIn(['schedulingSystemDetails', 'details']);
    const newMemo = order.getIn(['accountMemos', 'newMemo']);
    const memoAddError = order.getIn(['accountMemos', 'addMemoError']);
    const memosLoading = order.getIn(['accountMemos', 'loading']);
    const userId = user.get('userId');
    const techId = techData.getIn(['techs', userId, 'info', 'techId']);

    const memoRequest = {
        accountNo: customerDetails.get('accountNumber'),
        memo: newMemo,
        marketId: customerDetails.get('marketId'),
        userName: user
            .get('userId')
            .replace('@wideopenwest.com', '')
            .substring(0, 19),
        billingSystem: schedulingSystemDetails.get('billingSystem'),
        externalUserName: 'WWMTECTOOL',
        priority: 'Low'

    };

    let errorDisplay = null;

    if (memoAddError) {
        errorDisplay = (
            <div className="card-panel red darken-2 white-text">{memoAddError}</div>
        );
    }

    return (
        <div>
            {errorDisplay}
            <CommentForm
                memosLoading={memosLoading}
                accountActions={accountActions}
                memoRequest={memoRequest}
                orderId={orderId}
                userId={userId}
                techId={techId}/>
        </div>
    );
};

CommentTool.propTypes = {
    accountActions: PropTypes.object,
    workOrder: PropTypes.object,
    orderId: PropTypes.string,
    user: PropTypes.object,
    techData: PropTypes.object
};

function mapStateToProps(state) {
    return {
        workOrder: state.get('workOrder'),
        user: state.get('user'),
        techData: state.get('techData')
    };
}

function mapDispatchToProps(dispatch) {
    return {
        accountActions: bindActionCreators(accountActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CommentTool);



// WEBPACK FOOTER //
// ./src/containers/CommentTool.js